module.exports = __webpack_public_path__ + "static/media/PH3800__002_Explore.41d6d7a8.mp3";